module.exports = __webpack_public_path__ + "static/media/Hungry.9f98ebd1.webp";